import axios from "axios";

const API_URL = "/user-favourites/search";

export const userFavouritesApi = async (userId) => {
  try {
    const response = await axios.post(API_URL, { user_id: userId });
    const resData = response?.data?.data;

    return resData.length == 0 ? null : resData;
  } catch (error) {
    console.error("Error fetching user media:", error);
    return null;
  }
};

export const validateFavLimit = async (userId) => {
  const result = await userFavouritesApi(userId);
  const totalFavRecords = Number(result?.length ?? 0);

  // @TODO make the following limit configurable at some point
  return totalFavRecords < 20;
};
